export const MAX_XVVS_BOOST_FACTOR = 2.5
export const MAX_TOTAL_BOOST_FACTOR = 3
export const MAX_NUM_OF_BOOST_FARM = 2
export const MAX_NFT_SELECTABLE = 5
